import { render, staticRenderFns } from "./term5.vue?vue&type=template&id=185af117"
import script from "./term5.vue?vue&type=script&lang=js"
export * from "./term5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports